import(/* webpackMode: "eager", webpackExports: ["MenuPageClient"] */ "/var/www/gatelivebar/components/public/MenuPageClient.tsx");
